import React from 'react';
import { IconChevronDown24 } from '@dhis2/ui-icons';

const ExpandCell = (props) => (
  <td class="cell-leading-icon cell-expand-control">
    <IconChevronDown24 color="var(--colors-grey700" />
  </td>
);

export default ExpandCell;
